import { render } from "./CertAlcoholApproved.vue?vue&type=template&id=482864b1&scoped=true"
import script from "./CertAlcoholApproved.vue?vue&type=script&lang=js"
export * from "./CertAlcoholApproved.vue?vue&type=script&lang=js"

import "./CertAlcoholApproved.vue?vue&type=style&index=0&id=482864b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482864b1"]])

export default __exports__